import React from 'react';
import { Tooltip, Tag } from 'antd';

import './styles.css';

export default [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    sorter: true
  },
  {
    title: 'Asset Name',
    dataIndex: 'assetName',
    key: 'assetName',
    sorter: true
  },
  {
    title: 'Asset Identification Number',
    dataIndex: 'salesforceAssetId',
    key: 'salesforceAssetId',
    sorter: true,
    render: (_, { salesforceAssetId }) => (
      <Tooltip title="View Not Closed DVIRs Report for this vehicle">
        <a>{salesforceAssetId}</a>
      </Tooltip>
    )
  },
  {
    title: 'Asset Barcode Number',
    dataIndex: 'assetBarcode',
    key: 'assetBarcode',
    sorter: true,
    render: (_, { assetBarcode }) => (
      <Tooltip title="View Missing Inspection Vehicles Report for this vehicle">
        <a>{assetBarcode}</a>
      </Tooltip>
    )
  },
  {
    title: 'Market Manager Name',
    dataIndex: 'marketManagerName',
    key: 'marketManagerName',
    sorter: true
  },
  {
    title: 'Driver Full Name',
    dataIndex: 'driverFullName',
    key: 'driverFullName',
    sorter: true
  },
  {
    title: 'Location',
    dataIndex: 'branchName',
    key: 'branchName',
    sorter: true
  },
  {
    title: 'DVIR status',
    dataIndex: 'dvirStatus',
    key: 'dvirStatus',
    align: 'center',
    render: status => <Tag color={status === 'Closed' ? 'green' : 'red'}>{status}</Tag>
  },
  {
    title: 'Defective Item',
    dataIndex: 'defectiveItem',
    key: 'defectiveItem',
    render: (_, { defectiveItem }) => (
      <div className="defect-scroll" style={{ minWidth: '250px' }}>
        {defectiveItem}
      </div>
    )
  },
  {
    title: 'Asset Condition',
    dataIndex: 'assetCondition',
    key: 'assetCondition',
    sorter: true
  }
];
